import { useState } from "react";
import { toast } from "sonner";
import { adminApi, errText } from "./api";
import { Field, SaveBtn, Panel } from "./Fields";

const FIELDS = [
  ["webPanel", "Web giriş paneli adresi", "Menüdeki “Web Giriş” ve Kurulum'daki web butonu buraya gider"],
  ["android", "Android telefon uygulama bağlantısı", "Titan Android"],
  ["ios", "iOS (iPhone & iPad) uygulama bağlantısı", "Titan iOS"],
  ["windows", "Windows bilgisayar uygulama bağlantısı", "Titan Player"],
  ["box", "Android Box & TV uygulama bağlantısı", "Downloader"],
];

export const LinksEditor = ({ initial, onSaved }) => {
  const [l, setL] = useState({ ...(initial || {}), videos: { ...(initial?.videos || {}) } });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.put("/admin/links", l);
      toast.success("Bağlantılar kaydedildi");
      onSaved();
    } catch (ex) {
      toast.error(errText(ex).includes("pattern") ? "Bağlantılar http:// veya https:// ile başlamalı" : errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="admin-links-form">
      <Panel>
        <div className="grid gap-5">
          {FIELDS.map(([k, label, hint]) => (
            <Field key={k} id={`link-${k}`} label={label} hint={hint} value={l[k] || ""} required type="url"
              onChange={(e) => setL({ ...l, [k]: e.target.value.trim() })} data-testid={`admin-link-${k}`} />
          ))}
        </div>
        <p className="mt-6 text-sm text-[#c9c6f0]">Kurulum adımları ve videoları “Kurulum Rehberi” sekmesinden düzenleyebilirsin.</p>
        <div className="mt-8"><SaveBtn busy={busy} data-testid="admin-links-save" /></div>
      </Panel>
    </form>
  );
};
